module.exports = __webpack_public_path__ + "static/media/catBackground.12fe879f.png";